import type { ICurrentFee } from './useOrder'
import { getInviteRecordInfo, readRecordType } from '~/api/module/marketing'
import { INVITE_RECORD_TYPE } from '~/api/interface/marketing'
import { RIGHTS_TIME } from '~/constants/rights'

/**
 * 检查用户是否被邀请
 */
export default function useCheckUserInvited(currentFees: ICurrentFee) {
  const isInviteUser = ref(false)
  const inviterAward: any = ref({})

  async function getInviteInfo(success?: boolean) {
    const res = await getInviteRecordInfo({
      is_invitee: 0,
      many: true,
    })
    if (!res.code) {
      const { data } = res
      if (!success) {
        // 刚注册用户自动弹窗
        if (data?.length === 1) {
          isInviteUser.value = true
        } else {
          isInviteUser.value = false
        }
      }
      // 邀请用户首次购买成功
      if (success && data?.length && data?.length > 1) {
        const type =
          currentFees.time_identity === RIGHTS_TIME().month
            ? INVITE_RECORD_TYPE.MONTH
            : INVITE_RECORD_TYPE.YEAR
        inviterAward.value = res.data?.find(
          (item) => Number(item.goon_behavior_type) === Number(type)
        )
        await readRecordType(type, { record_id: inviterAward.value.id })
      }
    }
  }

  return {
    isInviteUser,
    inviterAward,
    getInviteInfo,
  }
}
